import { Box } from '@mui/material';
import { useMemo } from 'react';

import { ButtonGroup } from '@/components/form/baseInputs/ButtonGroup';
import { ButtonGroupInputOption } from '@/components/form/baseInputs/inputTypes';
import { Map01Icon } from '@/components/icons/Map01Icon';
import { useAICapabilitiesEnabled } from '@/modules/tenant/TenantDetailsContext/hooks/useAICapabilitiesEnabled';
import { zIndexes } from '@/styles/zIndexes';

import { getDocumentDetailsViewButtonOptions } from '../../documents.constants';
import { useHouseholdDocumentsViewerContext } from './context/HouseholdDocumentsViewer.context';
import { DocumentViewerTab } from './context/HouseholdDocumentsViewer.context';

interface DocumentSummarySwitchProps {
  /** Controls visibility of the Dispositive Diagram tab */
  showDiagram?: boolean;
}
export function DocumentSummarySwitch({
  showDiagram = false,
}: DocumentSummarySwitchProps) {
  const aiEnabled = useAICapabilitiesEnabled();

  const { documentViewerActiveTab, updateDocumentViewerActiveTab } =
    useHouseholdDocumentsViewerContext();

  const options: ButtonGroupInputOption<DocumentViewerTab>[] = useMemo(() => {
    const baseOptions = getDocumentDetailsViewButtonOptions();

    if (showDiagram) {
      return [
        {
          display: 'Diagram',
          value: 'diagram',
          buttonProps: {
            startIcon: Map01Icon,
          },
        },
        ...baseOptions,
      ];
    }

    return baseOptions;
  }, [showDiagram]);

  // Never show the summary option if tenant has AI disabled
  if (!aiEnabled) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: zIndexes.MENU,
      }}
    >
      <ButtonGroup
        label="Choose view type"
        hideLabel
        value={documentViewerActiveTab}
        options={options}
        onChange={(_, value) => updateDocumentViewerActiveTab(value)}
      />
    </Box>
  );
}
